/**
 * Forms
 */
import { CustomSelect } from './vendor/custom-select';

( function( $ ) {

    prettify_forms();
    setup_ngp_placeholders();

    /**
     * Prettify the forms
     */
     function prettify_forms() {

        prettify_selects();

        /**
         * Prettify select inputs
         */
        function prettify_selects() {

            var $select_inputs = document.querySelectorAll( '.gfield_select' );

            let i = 1;
            for( let $select of $select_inputs ) {

                // First make sure input has unique id
                $select.id = 'gform-select-' + i;

                // Now mask the input
                let custom_select = new CustomSelect({
                    elem: $select.id
                });

                i++;
            }

            setup_select_clicking();

            /**
             * Custom clicking functionality
             */
            function setup_select_clicking() {

                var $dropdowns = $('.js-Dropdown');
                var $dropdown_titles = $('.js-Dropdown-title');

                // Toggle when clicking title
                $dropdown_titles.on( 'click', function(e) {

                    $(this).parents( '.js-Dropdown' ).toggleClass( 'is-open' );

                } );

                // Toggle out when clicked outside of dropdown
                $(document).on( 'click', function(e) {

                    if(
                        $(e.target).parents( '.js-Dropdown-list' ).length ||
                        ! $(e.target).parents( '.js-Dropdown' ).length
                    ) {

                        $('.js-Dropdown.is-open').removeClass( 'is-open' );
                        $('.js-Dropdown-list.is-open').removeClass( 'is-open' );

                    }

                } );

                // document.addEventListener('click', function(e) {
                //     if (!selectContainer.contains(e.target)) close();
                // });
                        }
        }
     }

     /**
      * Setup ngp form placeholders.
      */
    function setup_ngp_placeholders() {

      $(document).ready( () => {

        setTimeout( () => {
          const $ngp_forms = $('input[placeholder="email@email.com"]');

          if( $ngp_forms.length ) {

            $ngp_forms.each( function() {
              $(this).attr( 'placeholder', 'Email address' );
            } )

          }
        }, 750);




      } );

    }

} )( jQuery );


// WEBPACK FOOTER //
// ./assets/frontend/scripts/main/forms.js